import React from 'react';

const ShiftCard = ({ children, isExpanded }) => {
  return (
    <div className="relative w-full max-w-[520px] mx-2 sm:mx-4">
      {/* Corner accents */}
      <div className="absolute -top-[2px] -left-[2px] w-3 sm:w-4 h-3 sm:h-4 border-t-2 border-l-2 border-cyan-500/50" />
      <div className="absolute -top-[2px] -right-[2px] w-3 sm:w-4 h-3 sm:h-4 border-t-2 border-r-2 border-cyan-500/50" />
      <div className="absolute -bottom-[2px] -left-[2px] w-3 sm:w-4 h-3 sm:h-4 border-b-2 border-l-2 border-cyan-500/50" />
      <div className="absolute -bottom-[2px] -right-[2px] w-3 sm:w-4 h-3 sm:h-4 border-b-2 border-r-2 border-cyan-500/50" />
      
      {/* Main card */}
      <div className="bg-[#0a1018]/95 border border-gray-800 backdrop-blur-sm transition-all duration-500 w-full">
        {children}
      </div>
    </div>
  );
};

export default ShiftCard;
